/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Tweaks visuais do app Forms dentro do Shadow DOM da página de senha
(function () {
  function applyStyles(root) {
    try {
      // Título (h2) e subtítulo (primeiro <p> após o título)
      const h2 = root.querySelector('h2');
      if (h2) {
        h2.style.fontWeight = '400';
        h2.style.fontSize = '22px';
        h2.style.lineHeight = '1.3';
        h2.style.letterSpacing = '0.3px';
        h2.style.marginBottom = '6px';
        h2.style.color = '#202020';
      }

      const subtitle = h2 ? h2.parentElement.querySelector('p') : root.querySelector('p');
      if (subtitle) {
        subtitle.style.fontWeight = '400';
        subtitle.style.fontSize = '14px';
        subtitle.style.opacity = '0.9';
        subtitle.style.margin = '0 0 16px 0';
        subtitle.style.color = '#202020';
      }

      // Campos
      root.querySelectorAll('input, select, textarea').forEach(el => {
        el.style.border = '1px solid #dcdcdc';
        el.style.borderRadius = '8px';
        el.style.boxShadow = 'none';
        el.style.fontWeight = '400';
        el.style.fontSize = '14px';
      });

      // Botão
      const btn = root.querySelector('button');
      if (btn) {
        btn.style.borderRadius = '8px';
        btn.style.fontWeight = '500';
        btn.style.fontSize = '15px';
        btn.style.letterSpacing = '0.3px';
      }

      // Rodapé / texto pequeno
      root.querySelectorAll('small, .fineprint').forEach(el => {
        el.style.fontSize = '12px';
        el.style.opacity = '0.8';
      });
    } catch (e) {
      console.warn('Forms style tweak skipped:', e);
    }
  }

  function handle(el) {
    const root = el.shadowRoot;
    if (!root) return;

    // aplica já
    applyStyles(root);

    // e reaplica se o app re-renderizar
    const mo = new MutationObserver(() => applyStyles(root));
    mo.observe(root, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('shopify-forms-embed').forEach(handle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


(function () {
  if (!document.documentElement.classList.contains('template-password')) return;

  var form = document.getElementById('password_signup');
  if (!form) return;

  form.addEventListener('submit', function () {
    var ddi   = (form.querySelector('[name="ddi"]') || {}).value || '+55';
    var local = (form.querySelector('[name="__phone_local"]') || {}).value || '';
    var phoneHidden = form.querySelector('input[name="customer[phone]"]');
    var smsHidden   = form.querySelector('input[name="customer[accepts_sms_marketing]"]');

    // limpa tudo que não é dígito
    var digits = (local || '').replace(/\D/g, '');
    // monta E.164
    var e164 = (ddi || '+55').replace(/\s/g, '');
    if (e164[0] !== '+') e164 = '+' + e164;
    e164 += digits;

    // Critério mínimo: pelo menos 8 dígitos no número local
    var hasValidPhone = digits.length >= 8;

    if (phoneHidden) phoneHidden.value = hasValidPhone ? e164 : '';
    if (smsHidden)   smsHidden.value   = hasValidPhone ? 'true' : ''; // só liga SMS se houver número

    // Opcional: se quiser bloquear envio quando o usuário digitou algo inválido:
    // if (local.trim() && !hasValidPhone) {
    //   alert('Telefone inválido. Informe com DDD.');
    //   event.preventDefault();
    // }
  });
})();

(function () {
  if (!document.documentElement.classList.contains('template-password')) return;

  var form = document.getElementById('password_signup');
  if (!form) return;

  form.addEventListener('submit', function () {
    var localInput = form.querySelector('[name="__phone_local"]');
    var phoneHidden = form.querySelector('input[name="customer[phone]"]');
    var smsHidden   = form.querySelector('input[name="customer[accepts_sms_marketing]"]');

    var raw = (localInput && localInput.value) ? localInput.value : '';
    var digits = raw.replace(/\D/g, '');               // só números

    // critério BR: pelo menos 10 dígitos (DDD + número)
    var hasValid = digits.length >= 10;

    if (hasValid) {
      // monta E.164 com +55
      var e164 = '+55' + digits;
      if (phoneHidden) phoneHidden.value = e164;
      if (smsHidden)   smsHidden.value   = 'true';      // liga SMS marketing
    } else {
      // sem telefone válido: não envia phone, não liga SMS
      if (phoneHidden) phoneHidden.value = '';
      if (smsHidden)   smsHidden.value   = '';
    }
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  var slideshow = document.querySelector('.Product__Slideshow');
  if (!slideshow || typeof Flickity === 'undefined') return;

  var flkty = Flickity.data(slideshow);
  if (!flkty) return;

  function loadImageInCell(cellEl) {
    if (!cellEl) return;

    var img = cellEl.querySelector('img.Image--lazyLoad[data-src]');
    if (!img) return;

    if (!img.getAttribute('src')) {
      img.setAttribute('src', img.getAttribute('data-src'));
    }

    if (window.lazySizes && typeof window.lazySizes.loader.unveil === 'function') {
      window.lazySizes.loader.unveil(img);
    }

    img.classList.add('Image--lazyLoaded');
  }

  function loadVisibleAndNeighbors() {
    var cells = flkty.cells.map(function (cell) {
      return cell.element;
    });

    var index = flkty.selectedIndex;
    var total = cells.length;

    if (!total) return;

    var prevIndex = (index - 1 + total) % total;
    var nextIndex = (index + 1) % total;

    loadImageInCell(cells[index]);
    loadImageInCell(cells[prevIndex]);
    loadImageInCell(cells[nextIndex]);
  }

  loadVisibleAndNeighbors();
  flkty.on('select', loadVisibleAndNeighbors);
  flkty.on('settle', loadVisibleAndNeighbors);
});

document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

  function runGalleryHint(slider) {
    if (!slider) return;
    if (slider.dataset.hintApplied === 'true') return;
    if (typeof Flickity === 'undefined') return;

    var flkty = Flickity.data(slider);
    if (!flkty) return;

    var track = slider.querySelector('.flickity-slider');
    if (!track) return;

    slider.dataset.hintApplied = 'true';

    setTimeout(function () {
      var originalTransform = track.style.transform || '';

      track.style.transition = 'transform 0.95s ease';
      track.style.transform = originalTransform + ' translateX(-68px)';

      setTimeout(function () {
        track.style.transform = originalTransform;

        setTimeout(function () {
          track.style.transition = '';
        }, 650);
      }, 650);
    }, 1200);
  }

  function initGalleryHints() {
    document.querySelectorAll('.Product__Slideshow').forEach(function (slider) {
      runGalleryHint(slider);
    });
  }

  initGalleryHints();
  setTimeout(initGalleryHints, 800);
  setTimeout(initGalleryHints, 1600);
});

